import React, { useState, useContext, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import {IProps, IState} from './types';
import * as S from './styles';
import * as Section from './BrandSection/styles';
import { RectangleIcon } from '@assets/icons/rectangle';
import { StartIcon } from '@assets/icons/startIcon';
import { Context } from "routes/private/Editor/Context";
import { getImageSrc } from '@utils/brand';
import { IDraggingData, IElement, IShapeCircleAttributes, IShapeCommonAttributes, IShapeEllipseAttributes, IShapeLineAttributes, IShapeRectangleAttributes, IShapeRhombusAttributes, IShapeStarAttributes, IShapeTriangleAttributes, IShapeTypes, ITextAttributes } from '@routes/private/Editor/types';
import DragElement from '../DragElement';
import { CircleIcon } from '@assets/icons/circleIcon';
import { TriangleIcon } from '@assets/icons/triangleIcon';
import { RhombusIcon } from '@assets/icons/rhombusIcon';
import { EllipseIcon } from '@assets/icons/ellipseIcon';
import { LineIcon, VerticalLineIcon } from '@assets/icons/lineIcon';
import Search from '@routes/private/BrandLibrary/components/Search';
import Filter from '@routes/private/BrandLibrary/components/Filter';
import { FilterIcon } from '@assets/icons/filterIcon';
import SearchBrandLibrary from './Search';
import BrandSection from './BrandSection';
import SearchList from './SearchList';
import SearchImages from '@routes/private/Editor/Editor/Pickers/SimilarImages/SearchImages';
import { IBrandImage } from '@state/brandsImages/types';
import { string } from 'prop-types';
import { sendFile, copyFile } from '@utils/cloudStorage';
import { setBrandImages } from '@state/brandsImages/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IUserFiles } from '@state/userFiles/types';
import { IImageList } from '../ImagePicker/types';
import { IDSConfig } from '@state/dsconfig/types';
import { IImageAttributes} from "routes/private/Editor/types";
import { containerName, containerNameBrands, storageAccountName } from '@storage/azure-storage-blob';
import { findElementById } from '@utils/editor';
import { getBoundingsWithDelta } from '@utils/geometry';
import { getWidthHeightFromSrc } from '@utils/userUtils';
import actions from '@state/actions';

const uuid = require('react-uuid');

const BrandLibraryPicker:React.FC<IProps> = (props) => {
  let context = useContext(Context);  
  const authContext = useContext(AuthContext);

  const [loadingImage, setLoadingImage] = useState(false);
  const [category, setCategory] = useState<string>();
  const [filesUrl, setFilesUrl] = useState<string[]>([]);
  const [selectecItemsSearch, setSelectecItemsSearch] = useState<IBrandImage[]|undefined>(undefined);
  const [droppedBrandImage, setDroppedBrandImage] = useState<IDraggingData | undefined>(undefined);
  let {editorStatus, onShowSearchImages, searchImages} = useContext(Context);
  const dispatch = useDispatch();
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const deltaBorder = dsConfig.editorConfig?.newElementSettings?.deltaBorder ?? 10;

  const handleOpenSearch=(value : string)=>{
    dispatch(setBrandImages([]));
    onShowSearchImages(true);
    setLoadingImage(false)
    setCategory(value.slice(0, -1));    
  }

    //to load files from URLs
    useEffect(() => {
      if (filesUrl.length > 0) addNewFiles(filesUrl,"URL");
    }, [filesUrl])

    useEffect(() => {
      const draggingData = editorStatus.draggingData;
      if (draggingData?.type === "Image" && draggingData?.itemData) {
        const setDimensions = async () => {
          let imageBrandInfo = draggingData.itemData;
          let srcFileOrg= `${urlBrand}/${imageBrandInfo.brandId}/${imageBrandInfo.imageType?imageBrandInfo.imageType.toLowerCase():""}/${imageBrandInfo.srcImage}`;
          const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
          if (dimensionsOrg) {
            imageBrandInfo.initWidth = dimensionsOrg.width;
            imageBrandInfo.initHeight = dimensionsOrg.height;
          }
          setDroppedBrandImage(draggingData);
        }
        setDimensions();
      }
    }, [editorStatus.draggingData]);

    useEffect(() => {
      if (droppedBrandImage?.itemData) {
        handleAddDropImage(droppedBrandImage.itemData, droppedBrandImage.containerId, droppedBrandImage.coorsPercentage, droppedBrandImage.elementCoorsPercentage);
        setDroppedBrandImage(undefined);
      }
    }, [JSON.stringify(droppedBrandImage)]);



    const addNewFiles = async (newFiles: any, filetype:string) => {    
      if (context.userFiles) {
        let newUserFiles = context.userFiles;      
        newUserFiles.files = [...newUserFiles.files, ...await convertUrlFiles(newFiles, context.userFiles.id)];      
        context.onEditUserFilesClose(newUserFiles);
      } else {
        const userData = {
          email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
          name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        const userFilesId = uuid();
        let newUserFiles: IUserFiles = {
          id: userFilesId,
          entityType: 'USERFILES',
          user: userData,
          files:  await convertUrlFiles(newFiles, userFilesId)
        }
        context.onEditUserFilesClose(newUserFiles);
      }
    }
  
    const convertUrlFiles = async (filesInput: any[], folder: string) => {    
  
      let newFiles = filesInput.map(fileInput=>{
        return{
          id: uuid(),
          thumbnail: '',
          type: 'image',
          date: new Date(),
          src: fileInput
        }
      })
  
      let nameFiles = newFiles.map(newFile=>{
          return `${folder}/${newFile.id}`        
      });
  
      let srcFiles = await Promise.all(newFiles.map(async newFile => {      
        return {
          ...newFile,
          src: await getBase64Url(`${folder}/${newFile.id}`, newFile.src, newFile)
        }
      }));
  
      
      //updateImageListArray(imageList,nameFiles,'uploading',srcFiles as IImageList[]);    
      sendUploadingFiles(srcFiles as IImageList[], folder);
      return newFiles;  
      
     
    }
  
    const getBase64Url = (name: string, url: string, userFile: IImageList) => {
  
      return new Promise((resolve, reject) => {    
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        request.onload = function() {
            var reader = new FileReader();
            reader.readAsDataURL(request.response);       
            reader.onload = function () {
              const result = reader.result?.toString();
              if (result) {            
                ////setArrayResult([...arrayresult, result])
                ////updateImageList(imageList, name, 'uploading', {...userFile, src: result});
                //sendFileResponse(name, result);                     
                resolve(result)
              }
            };
            reader.onerror = function (error) {
              console.error(error);
              reject(error)
            };
        };
        request.send();   
      });
      //return "";
    }
  
  
    const sendUploadingFiles = async (uploadImages:IImageList[], folder:string)=>
    {
      uploadImages.map(img=>{      
        if (img.src)
          sendFileResponse(`${folder}/${img.id}`, img.src);        
      });    
    }
  
    const sendFileResponse = async (name: string, data: string) => {
      try {
        await sendFile(name, data, dispatch);
        //context.onShowPicker("AddNewImage");
        //setFileResponse({name: name, status: 200});
      } catch(e) {
        //setFileResponse({name: name, status: 400});      
        console.error(e);
      }
    }
  
   
    const handleAddDropImage = async (imageBrandInfo: IBrandImage, id?: string, coors?: {x: number, y: number}, elementCoors?: {x: number, y: number}) =>{
      const selectedArtboards: string[] = context.editorStatus.selectedArtboardIds ? context.editorStatus.selectedArtboardIds : [];
      const idIndex = selectedArtboards.findIndex((artBoardId: string) => (artBoardId === id));
      if (id) {
        if (idIndex >= 0) {
          if (selectedArtboards.length === 1) handleAddImage([id], imageBrandInfo, coors, elementCoors);
          else handleAddImageManager(imageBrandInfo);
        } else {
          context.onSelectedArtboardChange(id);
          handleAddImage([id], imageBrandInfo, coors, elementCoors);
        }
      } else {
        handleAddImage([context.data[0].id], imageBrandInfo, coors, elementCoors);
      }
    }



    async function getImage(brandImage:IBrandImage){          
      //setLoadingImage(true)        
      const data: any = await getExternalImage(brandImage.srcImage)         
      if (data) 
      {

        let url = `${urlFiles}/${data}`
        var img = new Image();
        img.src = url;
        img.onload = (e) => {                   
          brandImage.initHeight = img.height;
          brandImage.initWidth = img.width;          
          brandImage.srcImage= data;
          handleAddImageManager(brandImage);                
        } 
      }
    }
  
    const getExternalImage = (url:string) => {          
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.getExternalImage(url, (result, error) => {                             
          if (error) reject(error)
          else {                 
            resolve(result)}
  
        }))
      });
    }
  
    


    const handleSelectImage=async (data:IBrandImage)=>{
             
      setLoadingImage(true)
      try {      
        if (data.srcImage.startsWith("http") && !data.srcImage.startsWith(urlFiles))
          getImage(data);        
        else
        {
            let srcFileOrg= `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}`;
            const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
            if (dimensionsOrg) {
              data.initWidth = dimensionsOrg.width;
              data.initHeight = dimensionsOrg.height;
            }
            handleAddImageManager(data);                      
        }
      } catch(error) {
        console.error(error);
      }
    
    }


    const handleAddImageManager = (imageBrandInfo:IBrandImage) => {
      setLoadingImage(false)
      let ids: string[] = [];
      if (context.data[0].type === "Artboards") {
        if (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length > 0) {
          editorStatus.selectedArtboardIds.map((id: string) => {
            ids = [...ids, id];
          });
        } else if (context.data[0]?.children && context.data[0]?.children.length > 0) {
          context.data[0].children.map((child: IElement) => {
            ids = [...ids, child.id];
          });
        }
        handleAddImage(ids, imageBrandInfo);
      } else {
        handleAddImage([context.data[0].id], imageBrandInfo);
      }
    }
  
    const handleAddImage = (ids: string[], imageBrandInfo:IBrandImage, coors?: {x: number, y: number}, elementCoors?: {x: number, y: number}) => {
      try {
        let newImageElements: IElement[] = [];
        let imageWidth = imageBrandInfo.initWidth??200;
        let imageHeight = imageBrandInfo.initHeight??200;
        const originalWidth = imageWidth, originalHeight = imageHeight;
        let elementIds: string[] = [];
        ids.map(id => {
          const imageElementId = uuid();
          let parentElement: IElement | undefined = findElementById(context.data, id);
          if (parentElement === undefined) parentElement = context.data[0];
          const recalculatedSizes = getBoundingsWithDelta(deltaBorder, originalWidth, originalHeight, parentElement.attributes.width, parentElement.attributes.height);
          imageWidth = recalculatedSizes.width;
          imageHeight = recalculatedSizes.height;
          let coorX = parentElement.attributes.x;
          let coorY = parentElement.attributes.y;
          if (coors && elementCoors) {
            coorX += coors.x * parentElement.attributes.width - elementCoors.x * imageWidth;
            coorY += coors.y * parentElement.attributes.height - elementCoors.y * imageHeight;
          } else {
            coorX += parentElement.attributes.width/2 - imageWidth/2;
            coorY += parentElement.attributes.height/2 - imageHeight/2;
          }
          const newAtributes: IImageAttributes = {
            x: coorX,
            y: coorY,
            width: imageWidth,
            height: imageHeight,
            srcImage: imageBrandInfo.srcImage,
            brandId: imageBrandInfo.brandId,
            brandImageType: imageBrandInfo.imageType,
            hidden: false,
            image: {x: coorX, y: coorY, width: imageWidth, height: imageHeight}
          };
          const newImageElement: IElement = {
            id: imageElementId,
            name: imageElementId,
            type: "Image",
            attributes: newAtributes
          };
          newImageElements = [...newImageElements, newImageElement];
          elementIds = [...elementIds, imageElementId]
        });        

        context.onCommandChange("addElement", undefined, ids, newImageElements);
        onShowSearchImages(false);
      } catch(error) {
        console.error(error);
      }
    }
  
  const handleOnSelect = async(imageInfo: any) => {
    let srcFileOrg= `${urlBrand}/${imageInfo.brandId}/${imageInfo.imageType?imageInfo.imageType.toLowerCase():""}/${imageInfo.srcImage}`;
    const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
    if (dimensionsOrg) {
      imageInfo.initWidth = dimensionsOrg.width;
      imageInfo.initHeight = dimensionsOrg.height;
    }
    handleAddImageManager(imageInfo);
  }

  return (
    <>
    <S.Root>
      <SearchBrandLibrary category={category} onSelect={(branImages: IBrandImage[]) => setSelectecItemsSearch(branImages)  }></SearchBrandLibrary>      
    </S.Root>
      {selectecItemsSearch 
      ? <SearchList imagesList={selectecItemsSearch} onSelect={(imageInfo: any) => handleOnSelect(imageInfo)}/>
      :
      <S.RootBody>
        <BrandSection section='vehicles' title='Vehicle Images' openSearch={(category: string) => handleOpenSearch(category)} onSelect={(imageBrandInfo:IBrandImage) => handleAddImageManager(imageBrandInfo)}></BrandSection>
        <BrandSection section='logos' title='Logos' openSearch={(category: string) => handleOpenSearch(category)} onSelect={(imageBrandInfo:IBrandImage) => handleAddImageManager(imageBrandInfo)}></BrandSection>
        <BrandSection section='backgrounds' title='Background Images' openSearch={(category: string) => handleOpenSearch(category)} onSelect={(imageBrandInfo:IBrandImage) => handleAddImageManager(imageBrandInfo)}></BrandSection>
        <BrandSection section='stocks' title='Stock Images' openSearch={(category: string) => handleOpenSearch(category)} onSelect={(imageBrandInfo:IBrandImage) => handleAddImageManager(imageBrandInfo)}></BrandSection>
      </S.RootBody>}
      { searchImages &&    
        <SearchImages open={searchImages} setOpen={(show: boolean)=>{onShowSearchImages(show)}} onSelect={(data:IBrandImage)=>{handleSelectImage(data)}} category={category} loadingImage={loadingImage} />
      } 
    </>
  );
}

export default BrandLibraryPicker;